import { Box } from "@mui/material";
import React, { Fragment } from "react";
import classess from "./Style.module.css";

const D2T = ({ ST1, ST2, T1, T2, MT, Bac }) => {
  return (
    <Fragment>
      <Box className={classess.WP} sx={{ marginTop: MT }}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: index === 1 ? "80px" : "250px",
                backgroundColor: Bac,
              }}
            >
              {index === 0 ? (
                <span className={classess.tooltip0} data-title={T1}>
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2 === null
          ? null
          : ST2.slice()
              .reverse()
              .map((opt, index) => (
                <Box
                  key={index}
                  className={classess.WB}
                  sx={{
                    width: index === 1 ? "80px" : "250px",
                    backgroundColor: Bac,
                  }}
                >
                  {index === 0 ? (
                    <span className={classess.tooltip0} data-title={T2}>
                      {opt}
                    </span>
                  ) : (
                    opt
                  )}
                </Box>
              ))}
      </Box>
    </Fragment>
  );
};

export default D2T;
